<template>
    <div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
        <el-page-header @back="goBack" :content="id ? '编辑渠道' : '添加渠道'"></el-page-header>
        <el-form label-position="right" :model="item" ref="ruleForm" label-width="auto">
            <el-form-item label="渠道名称" prop="name" :rules="[
                 {required: true, message: '请输入渠道名称'},
            ]">
                <el-input v-model="item.name" placeholder="请输入渠道名称"></el-input>
            </el-form-item>
            <el-form-item label="联系人" prop="link_man" :rules="[
                 {required: true, message: '请输入联系人'},
            ]">
                <el-input v-model="item.link_man" placeholder="请输入联系人"></el-input>
            </el-form-item>
            <el-form-item label="手机号码" prop="mobile" :rules="[
                 {required: true, message: '请输入手机号码'},
            ]">
                <el-input v-model="item.mobile" placeholder="请输入手机号码"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password">
                <el-input v-model="item.password" placeholder="请输入密码"></el-input>
            </el-form-item>
            <el-form-item label="到期时间">
                <el-radio-group v-model="item.time_type">
                    <el-radio :label="1">永久到期</el-radio>
                    <el-radio :label="0">自定义时间</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="" v-if="item.time_type == 0">
                <el-date-picker
                        v-model="item.expire_time"
                        type="date"
                        placeholder="选择到期时间">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="是否开启">
                <el-radio-group v-model="item.status">
                    <el-radio :label="1">开启</el-radio>
                    <el-radio :label="0">关闭</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="是否开启自动推送订单">
                <el-radio-group v-model="item.is_auto_push">
                    <el-radio :label="1">开启</el-radio>
                    <el-radio :label="0">关闭</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="推送地址" prop="push_url">
                <el-input v-model="item.push_url" placeholder="请输入"></el-input>
            </el-form-item>
			<el-form-item>
                    <el-button size="big" type="primary" @click="checkSubmit">保存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                list:[],
                item: {
                    time_type: 1,
                    expire_time: '',
                    status: 1
                },
                // 对比提交
                items:{},
                oldItem:{},
                isLoad: false,
                id: this.$route.query.id,
                dialogVisible: false,
                idCardImage: [],
                licenseImage: [],
            }
        },
        created() {
            if (this.id) {
                this.loadData()
            }
        },
        methods: {
            onlyNum(){

            },
            loadData() {
                if (this.isLoad) {
                    return
                }
                this.isLoad = !this.isLoad
                this.axios.post('/admin/channel/detail', {
                    // 请求查询的数据 id为undefined的时候没有值
                    channel_id: this.id
                }).then(res => {
                    this.isLoad = !this.isLoad
                    // item是基础信息
                    this.item = res.data.detail
                }).catch(() => {
                    this.isLoad = !this.isLoad
                })
            },
            // 后退一步
            goBack() {
                this.$router.back(-1)
            },
            checkSubmit(){
                this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
                        this.submit()
                    } else {
                        this.$message.warning("请检查表单信息是否正确");
                        return false;
                    }
                });
            },
            // 提交
            submit() {
                if (this.isLoad) {
                    return
                }
                this.isLoad = !this.isLoad
                this.dialogVisible = false

                var form = Object.assign({}, this.item)
                let url = ''
                if (this.id) {
                    url = '/admin/channel/update'
                    form.channel_id = this.id
                } else {
                    url = '/admin/channel/add'
                }

                this.axios.post(url, form)
                    .then(() => {
                        this.isLoad = !this.isLoad
                        this.$message.success({
                            message: '保存成功'
                        });
                        this.goBack()
                    })
                    .catch(() => {
                        this.isLoad = !this.isLoad
                    })
            },
           uploadError() {
                this.$message.error({
                    message: '上传失败'
                });
            },
            beforeUpload(file) {
                var testmsg = file.type;
                const extension = (testmsg === "image/jpeg" || testmsg === "image/png");
                if (!extension ) {
                    this.$message({
                        message: "上传文件只能是jpg或png格式!",
                        type: "warning",
                    });
                }
                return extension;
            },

            uploadSuccess(res, file) {
                file.name = file.raw.name
                // file.name = res.data.src
                this.idCardImage = [file]
                this.$message.success({
                    message: '上传成功'
                });
            },
            uploadRemove: function () {
                this.idCardImage = []
            },

            uploadSuccess1(res, file) {
                file.name = file.raw.name
                this.licenseImage = [file]
                this.$message.success({
                    message: '上传成功'
                });
            },
            uploadRemove1: function () {
                this.licenseImage = []
            }
        }
    }
</script>
<style scoped>
</style>
